import 'babel-polyfill';
import VConsole from 'vconsole';
import React from 'react';
import ReactDOM from 'react-dom';
import { hashHistory, Router, Route } from 'react-router';
import './index.less';
import Author from './routes/author';
import AuthorAgreement from './routes/author/contract/authorAgreement';
import SignAgreement from './routes/author/contract/signAgreement';
import AgreementDetail from './routes/author/contract/agreementDetail';
import Result from './routes/author/result/index';
import AcceptOrder from './routes/acceptOrder/index';
import registerServiceWorker from './registerServiceWorker';
import contractManage from './routes/contractManage/index';
import contractDetail from './routes/contractManage/detail';
import PersonalInfo from './routes/personalInfo/index';
import BasicInfo from './routes/personalInfo/basicInfo';
import Personal from './routes/personalInfo/personal';
import Certification from './routes/personalInfo/certification';
import Protocols from './routes/protocols'
import ProcessInfo from './routes/personalInfo/processInfo';
import LocationInfo from './routes/personalInfo/locationInfo';
import ImageInfo from './routes/personalInfo/imageInfo';

/**---------------埋点--------------- */
import { getPathParams } from './utils/utils';
import { loadTraceServer } from './tf-traceService';

window.sourceCode = 5201000600;
const info = getPathParams(window.location.href);
localStorage.setItem('ShipperInfo', JSON.stringify({ partyId: info && info.partyId }))

// let vConsole = new VConsole();

const isPro = (window.location.href.indexOf('test') > -1 || window.location.href.indexOf('localhost') > -1 || window.location.href.indexOf('mytest') > -1) ? false : true

loadTraceServer({
    type: 'hash',
    isPro,
    userId: info && info.partyId,
    sourceCode: window.sourceCode
});

window.addEventListener('load', () => {
    window.sessionStorage.removeItem('paramObj')
    window.sessionStorage.removeItem('identifyingCode')
    window.sessionStorage.removeItem('templetUniqueCodes')
})

ReactDOM.render(
    <Router history={hashHistory}>
        <Route path="/" />
        <Route path="author" component={Author} />
        <Route path="signAgreement" component={SignAgreement} />
        <Route path="authorAgreement" component={AuthorAgreement} />
        <Route path="agreementDetail" component={AgreementDetail} />
        <Route path="Result" component={Result} />
        <Route path="acceptOrder" component={AcceptOrder} />
        <Route path="contractManage" component={contractManage} />
        <Route path="contractDetail" component={contractDetail} />
        <Route path="personalInfo" component={PersonalInfo} />
        <Route path="basicInfo" component={BasicInfo} />
        <Route path="processInfo" component={ProcessInfo} />
        <Route path="personal" component={Personal} />
        <Route path="certification" component={Certification} />
        <Route path="protocols" component={Protocols} />
        <Route path="locationInfo" component={LocationInfo} />
        <Route path="imageInfo" component={ImageInfo} />
    </Router>, document.getElementById('root'));
registerServiceWorker();



// 监控预警调用
window.WatchService && window.WatchService.init({
    // 总开关
    enableSDK: true,
    // 上报地址
    reportUrl: isPro ? 'https://s.tf56.com/tfmonitor/fpush' : 'https://stest.tf56.com/tfmonitor/fpush',
    // 项目id
    sourceCode: window.sourceCode,
    // 环境
    environment: isPro ? 'pro' : 'test',
    // 是否上报ajax错误数据
    isAjax: false,
    //  是否上报静态资源是localhost 的错误
    enableLocalResourceError: false,
    // 应用名称  ***新增   ---必填
    applicationName: '陆运通司机授权H5',
    applicationType: 'web',
})


// WEBPACK FOOTER //
// ./src/index.js